import { HttpUrlEncodingCodec } from "@angular/common/http";
import { Service } from "@angular/core";

@Service()
export class CustomEncoder extends HttpUrlEncodingCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }

  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }
}
